export default __webpack_public_path__ + "static/media/iste4.1e81fe84.png";